import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { FormErrorsComponent, IconModule } from '@spartacus/storefront';
import { ErrorParamsPipe } from '../../pipes';

@Component({
  selector: 'sd-form-field-new',
  templateUrl: './form-field-new.component.html',
  styleUrls: ['./form-field-new.component.scss'],
  imports: [NgIf, IconModule, FormErrorsComponent, ErrorParamsPipe],
  // Дефолтная стратегия, чтобы реагировал на изменения formControl
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormFieldNewComponent {
  @Input() label: string;
  @Input() hint: string;
  @Input() required = false;
  @Input() control?: FormControl;

  iconType = CUSTOM_ICON_TYPE;
}
